import React from 'react';

function StudentHomeScreen() {
  return (
    <div>
      <h2>Welcome, Student!</h2>
      {/* Student-specific components */}
    </div>
  );
}

export default StudentHomeScreen;
